import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=ba8747ae&scoped=true"
import script from "./Secret.vue?vue&type=script&lang=js"
export * from "./Secret.vue?vue&type=script&lang=js"
import style0 from "./Secret.vue?vue&type=style&index=0&id=ba8747ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8747ae",
  null
  
)

export default component.exports